import { ICellRendererParams } from 'ag-grid-community';
import { useState } from 'react';

import { PartContent } from 'bom/components';
import { BomPartType, ComponentStatus } from 'bom/enums';
import { IBomPart } from 'bom/types';
import { getAgGridTableCellData } from 'core/utils';
import { UpsertLine } from 'jobs/components/JobDetails';
import { IJobPart } from 'jobs/types';
import { PartNumberHelper } from 'parts/helpers';

interface IProps extends ICellRendererParams {
  isEditable: (jobPart: IJobPart) => boolean;
  onPartNumberClick: (jobPart: IJobPart) => void;
}

export const PartNumberCell = ({ isEditable, onPartNumberClick, ...props }: IProps) => {
  const [isEditOpen, setIsEditOpen] = useState(false);

  const data = getAgGridTableCellData(props, 'partNumber') as IJobPart;

  const isGroupedByColumn = props?.node?.rowGroupColumn?.getColId() === 'partNumber';

  if (!data || isGroupedByColumn) {
    return PartNumberHelper.toLabel(props?.value);
  }

  const isRowEditable = isEditable(data);

  return (
    <>
      <PartContent
        bomPart={data}
        onPartNumberClick={(bomPart: IBomPart) => onPartNumberClick(bomPart as IJobPart)}
        onEditPartLineClick={() => setIsEditOpen(true)}
        isEditable={data.type === BomPartType.COMPONENT && isRowEditable}
        isDeleted={data.status === ComponentStatus.DELETED}
      />

      <UpsertLine
        jobId={data.bomId}
        jobPart={data}
        isOpen={isEditOpen}
        onClose={() => setIsEditOpen(false)}
      />
    </>
  );
};
